'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = pdpDisplayHelper;

var _item = require('dibs-selectors/dist/item');

var itemSelectors = _interopRequireWildcard(_item);

var _buyerDisplayHelper = require('./buyerDisplayHelper');

var _buyerDisplayHelper2 = _interopRequireDefault(_buyerDisplayHelper);

var _getPricingData2 = require('./utils/getPricingData');

var _getPricingData3 = _interopRequireDefault(_getPricingData2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function pdpDisplayHelper(_ref) {
    var buyerId = _ref.buyerId,
        _ref$buyerHasTradePer = _ref.buyerHasTradePermission,
        buyerHasTradePermission = _ref$buyerHasTradePer === undefined ? false : _ref$buyerHasTradePer,
        item = _ref.item;

    if (!item) {
        throw new Error('Item is required');
    }

    var itemIsFurniture = itemSelectors.isFurniture(item);
    var itemIsSold = itemSelectors.isSold(item);
    var salePrice = itemSelectors.getSalePrice(item);
    var retailPrice = itemSelectors.getRetailPrice(item);
    var netPrice = itemSelectors.getNetPrice(item);

    var _getPricingData = (0, _getPricingData3.default)({
        salePrice: salePrice,
        netPrice: netPrice,
        retailPrice: retailPrice
    }),
        pricingShowSale = _getPricingData.pricingShowSale,
        pricingNegotiableRetail = _getPricingData.pricingNegotiableRetail,
        pricingNegotiableSale = _getPricingData.pricingNegotiableSale,
        pricingData = _objectWithoutProperties(_getPricingData, ['pricingShowSale', 'pricingNegotiableRetail', 'pricingNegotiableSale']);

    var displays = (0, _buyerDisplayHelper2.default)(_extends({
        buyerHasTradePermission: buyerHasTradePermission,
        buyerOwnsActiveHold: itemSelectors.isActiveHoldByBuyerId(item)(buyerId),

        itemIsFurniture: itemIsFurniture,
        itemIsOnHold: itemSelectors.isOnHold(item),
        itemIsSold: itemIsSold,

        pricingShowSale: pricingShowSale,
        pricingNegotiableRetail: pricingNegotiableRetail,
        pricingNegotiableSale: pricingNegotiableSale
    }, pricingData));

    return {
        getShowCTAs: function getShowCTAs() {
            var ctaDisplays = displays.getShowCTAs();

            if (itemIsSold) {
                return { showFollowing: true };
            } else if (pricingShowSale && !pricingNegotiableSale) {
                return _extends({}, ctaDisplays, { showMakeOfferCTA: false });
            }

            return ctaDisplays;
        },
        getShowPrices: function getShowPrices() {
            var priceDisplays = displays.getShowPrices();

            if (priceDisplays.showOnHold) {
                var pricingHideRetail = pricingData.pricingHideRetail,
                    pricingValidNet = pricingData.pricingValidNet;

                var netTradeable = buyerHasTradePermission && itemIsFurniture;

                var showRetailPrice = !pricingHideRetail && !itemIsSold;
                var showNetPrice = netTradeable && pricingValidNet && !itemIsSold;

                Object.assign(priceDisplays, {
                    showNetPrice: showNetPrice,
                    showRetailPrice: showRetailPrice,
                    showSalePrice: itemIsSold,
                    showListPriceLabel: netTradeable && showRetailPrice,
                    showPriceUponRequest: !showNetPrice && !showRetailPrice && !itemIsSold
                });
            }

            if (priceDisplays.showSold) {
                return { showSold: true };
            } else if (priceDisplays.showSalePrice) {
                var saleDisplay = _extends({}, priceDisplays, { showRetailPrice: true, showReducedFrom: true });
                return buyerHasTradePermission ? _extends({}, saleDisplay, { showListPriceLabel: true }) : saleDisplay;
            }

            return priceDisplays;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/dibs-display-helpers/dist/pdpDisplayHelper.js
// module id = 1643
// module chunks = 64